import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { deleteExtensiveAttributeValues } from 'api/extensive-attribute-value.service';

export const EXTENSIVE_ATTRIBUTE_VALUE_DELETE_STORE_NAME = 'extensiveAttributeValueDelete';

export const dropExtensiveAttributeValues = createAsyncThunk(
  `${EXTENSIVE_ATTRIBUTE_VALUE_DELETE_STORE_NAME}/delete`,
  (payload: { projectId: string, extensiveAttributeDefinitionId: string, extensiveAttributeValueId: string}, thunkAPI) => {
    const { projectId, extensiveAttributeDefinitionId, extensiveAttributeValueId } = payload;
    return deleteExtensiveAttributeValues(projectId, extensiveAttributeDefinitionId, extensiveAttributeValueId);
  },
);

export interface ExtendiveAttributeValueDeleteState {
  processing: boolean
  succeeded: boolean
  error: any
}

export const initialExtensiveAttributeValueDeleteState: ExtendiveAttributeValueDeleteState = {
  processing: false,
  succeeded: false,
  error: null,
};

export const extensiveAttributeValueDeleteSlice = createSlice({
  name: EXTENSIVE_ATTRIBUTE_VALUE_DELETE_STORE_NAME,
  initialState: initialExtensiveAttributeValueDeleteState,
  reducers: {
    clear: (state) => {
      state.error = initialExtensiveAttributeValueDeleteState.error;
      state.processing = initialExtensiveAttributeValueDeleteState.processing;
      state.succeeded = initialExtensiveAttributeValueDeleteState.succeeded;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(dropExtensiveAttributeValues.pending, (state) => {
      state.processing = true;
    });
    builder.addCase(dropExtensiveAttributeValues.fulfilled, (state) => {
      state.processing = false;
      state.succeeded = true;
    });
    builder.addCase(dropExtensiveAttributeValues.rejected, (state, action) => {
      state.error = action.payload;
      state.processing = false;
    });
  },
});

export const extensiveAttributeValueDeleteActions = {
  ...extensiveAttributeValueDeleteSlice.actions,
  dropExtensiveAttributeValues,
};

export default extensiveAttributeValueDeleteSlice.reducer;
